<section class="page-banner">
    <div class="page-title-container">
        <div class="page-title">
            {{ 'About Best Auto Body' }}
        </div>
        <div class="page-subtitle" [innerHTML]="'When it comes to the performance of your vehicle, you want quality service from trusted professionals. We’ll help you stay on the road so you can reach your next great destination.' | translate"></div>
    </div>
    <div class="page-screen"></div>
</section>
<section id="aboutus" class="margin-top-3">
    <div class="d-flex flex-row justify-content-center">
        <div class="page-layout max-width">
            <div class="page-layout-content">
                <div class="page-section">
                    <div class="section-title-alt">{{ 'Know About Us' | translate }}</div>
                    <div id="aboutus-intro">
                        <div class="images-wrapper">
                            <img [src]="'/assets/about-1.jpg'" class="image">
                            <img [src]="'/assets/about-2.jpg'" class="image">
                        </div>
                        <div class="text-container">
                            <h5 class="font-main3">{{ "Complete Service for Your Car" | translate }}</h5>
                            <p translate>A well maintained vehicle is more fuel efficient, more reliable, and will last longer, making the most of your auto investment. And the Best Auto Body is the perfect automobile partner.</p>
                            <p translate>We have 9 years of experience in this field, Best Auto Body is your one stop solution bringing best car services in Northern Virginia for all majors car care requirements. Our technicians are trained to perform diagnostic and repair services on all makes and models, and we can take care of your factory recommended maintenance service as well.</p>
                            <p translate>We provide car maintenance and car repair services wherever you are. From routine maintenance like oil changes and tire rotations to wear-related repairs including brake repair, mufflers and exhaust, and steering and suspension repairs, our technician have you covered.</p>
                            <p translate>Book your appointment today.</p>
                        </div>
                    </div>
                </div>
                <div id="why_choose_us" class="page-section">
                    <div class="section-title-alt" translate>Why Choose Us</div>
                    <div class="item-list">
                        <ul>
                            <li>
                                <i class="icon-car-wash"></i>
                                {{ '100% Transparency' | translate }}
                            </li>
                            <li>
                                <i class="icon-brake-disc"></i>
                                {{ 'Genuine Spare Part' | translate }}
                            </li>
                            <li>
                                <i class="icon-winner"></i>
                                {{ 'Trusted & Quaility Service' | translate }}
                            </li>
                            <li>
                                <i class="icon-mechanic"></i>
                                {{ 'Friendly & Helpful Team' | translate }}
                            </li>
                            <li>
                                <i class="icon-tow-truck"></i>
                                {{ 'Free Pickup & Delivery' | translate }}
                            </li>
                            <li translate>
                                <i class="icon-money-bag"></i>
                                {{ 'Zero Upselling' | translate }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="page-layout-sidebar page-section">
                <div class="sidebar-widget">
                    <h5 class="font-main3">{{ 'Working Hours' | translate }}</h5>
                    <div class="row mb-2">
                        <div class="col-3">Mon:</div>
                        <div class="col-9">8:00 AM ~ 6:00 PM</div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-3">Tue:</div>
                        <div class="col-9">8:00 AM ~ 6:00 PM</div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-3">Wed:</div>
                        <div class="col-9">8:00 AM ~ 6:00 PM</div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-3">Thu:</div>
                        <div class="col-9">8:00 AM ~ 6:00 PM</div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-3">Fri:</div>
                        <div class="col-9">8:00 AM ~ 6:00 PM</div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-3">Sat:</div>
                        <div class="col-9">8:00 AM ~ 2:00 PM</div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-3">Sun:</div>
                        <div class="col-9">Close</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
